import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-student-settings-card',
  templateUrl: './student-settings-card.component.html',
  styleUrls: ['./student-settings-card.component.scss']
})
export class StudentSettingsCardComponent implements OnDestroy{
  @Input() cityList: any[];
  formsTouched = false;
  changeCity(city) {
    this.formsTouched = true;
    if (city.text === 'No Preference') {
      this.cityList.forEach(c => c.checkedValue = false);
      city.checkedValue = true;
      return;
    }
    const noPreferenceCheckbox = this.cityList.find(c => c.text === 'No Preference');
    if (noPreferenceCheckbox) {
      noPreferenceCheckbox.checkedValue = false;
    }
    city.checkedValue = !city.checkedValue;
  }

  getSettingsData() {
    return {cityList: this.cityList};
  }
  ngOnDestroy() {
    this.formsTouched = false;
  }

}
